import { classNames } from "../../helpers/classNames";
import Button from "./Button";

/**
 * The desktop "Your book" card (docs/design/HANDOFF.md, "Desktop side
 * panel"): cover preview, title, a few label/value rows (page count, price),
 * the primary action and Back. Rendered by `WizardShell` on lg and up.
 *
 * `cover` is the cover as it prints (builder/CoverPreview: drawing, brush band
 * and title), sized here to the panel.
 * `rows`  [{ label, value }]
 * `back`  { to | onClick, label, disabled }
 */
const BookSidePanel = ({ heading = "Your book", cover = null, title = null, rows = [], primary = null, back = null, note = null, compact = false, children, className }) => (
  <aside className={classNames("flex flex-col gap-5 rounded-[20px] border border-md-pink-light-1 bg-white p-7", className)}>
    <div className="text-[13px] font-bold uppercase tracking-[0.06em] text-md-muted">{heading}</div>
    {compact ? (
      // Steps 4 and 5 (Desk4Design, Desk5Preview): a small thumbnail beside the title, the
      // first row as its caption, then the rest under a rule.
      <div className="flex items-center gap-3.5">
        <div className="relative w-[60px] flex-shrink-0 overflow-hidden rounded-md">{cover}</div>
        <div className="flex min-w-0 flex-col gap-0.5">
          {title ? <span className="truncate text-base font-bold text-md-dark">{title}</span> : null}
          {rows[0] ? <span className="text-sm text-md-muted">{rows[0].label}</span> : null}
        </div>
      </div>
    ) : cover ? (
      <div className="relative mx-auto w-[210px] overflow-hidden rounded-[10px]">{cover}</div>
    ) : null}
    {!compact
      ? rows.map((row) => (
          <div key={row.label} className="flex justify-between text-[15px]">
            <span className="text-md-muted">{row.label}</span>
            <span className="font-bold text-md-dark">{row.value}</span>
          </div>
        ))
      : null}
    {children}
    {compact
      ? rows.slice(1).map((row) => (
          <div key={row.label} className="flex justify-between border-t border-md-pink-light-1 pt-4 text-[15px]">
            <span className="text-md-muted">{row.label}</span>
            <span className="font-bold text-md-dark">{row.value}</span>
          </div>
        ))
      : null}
    {(primary || back) && (
      <div className="flex flex-col gap-1.5">
        {primary}
        {note ? <div className="text-center text-[13px] text-md-muted">{note}</div> : null}
        {back ? (
          <Button variant="text" to={back.to} onClick={back.onClick} disabled={!!back.disabled} fullWidth>
            {back.label || "Back"}
          </Button>
        ) : null}
      </div>
    )}
  </aside>
);

export default BookSidePanel;
